var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',[_c('div',{class:["icon-page"]},_vm._l(((_vm.iconList)),function(item,index){return _c('div',{key:item.index,class:["icon-item"]},[_c('div',{class:["icon-wrapper"]},[_c('icon-example',{attrs:{"type":(item)}})],1),_c('div',{class:["icon-type"]},[_vm._v("cubeic-"+_vm._s(item))])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }